import { render } from "./MWAgenda.vue?vue&type=template&id=56695a64"
import script from "./MWAgenda.vue?vue&type=script&lang=js"
export * from "./MWAgenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__